import useInterval from './use-interval';
import { useNumber } from 'react-hanger';
import { useEffect } from 'react';

/**
 * 秒倒计时
 * @param initSeconds 初始总秒数
 * @param callback 秒数倒计时到0时 回调
 * @returns {number} 秒数
 */
const useSecondsTimer = (initSeconds, callback) => {
  const seconds = useNumber(initSeconds, { lowerLimit: 0 });

  useInterval(
    () => {
      seconds.decrease();
    },
    seconds.value > 0 ? 1000 : null,
  );

  useEffect(() => {
    if (seconds.value === 0) {
      callback && callback();
    }
  }, [seconds.value]);

  return seconds.value;
};

export default useSecondsTimer;
